import { FC, HTMLAttributes } from "react";
import clsx from "clsx";

import ImageTextCard from "@/components/cards/ImageTextCard";
import { ICard } from "../home/ServicesSection";
import RevealOnScroll from "@/components/common/RevealOnScroll";

// ----------------------------------------------------------------------------------

type IVisionMissionSectionProps = HTMLAttributes<HTMLDivElement> & {
  heading?: string;
  description?: string[];
  cards?: ICard[];
};

const VisionMissionSection: FC<IVisionMissionSectionProps> = ({
  heading,
  description,
  cards,
  className,
  ...other
}) => {
  return (
    <div
      className={clsx(
        "container mx-auto grid grid-cols-12 gap-5 py-14 md:gap-7 md:py-20 xl:py-24",
        className,
      )}
      {...other}
    >
      {(!!heading || !!description) && (
        <RevealOnScroll className="col-span-full mb-1">
          <div className="flex flex-col items-center justify-center gap-6 rounded-2xl bg-primary-100 px-5 py-10 text-center md:py-14 lg:py-20">
            {heading && (
              <h2 className="max-w-[648px] px-2 font-bricolage-grotesque text-h6 font-medium text-black-900 lg:text-h5 xl:text-h4">
                {heading}
              </h2>
            )}

            {description &&
              description.map((p) => (
                <p
                  className="mx-auto max-w-[493px] text-center text-base font-normal text-black-700"
                  key={p}
                >
                  {p}
                </p>
              ))}
          </div>
        </RevealOnScroll>
      )}

      {cards?.map((card, idx) => (
        <RevealOnScroll
          key={idx}
          index={idx}
          className="col-span-12 h-full md:col-span-6 xl:col-span-4"
        >
          <ImageTextCard
            icon={card.icon}
            heading={card.heading}
            description={card.description}
            className="group h-full rounded-2xl !bg-primary-50 p-5 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg lg:px-8 lg:py-12"
            iconHeight={70}
            iconWidth={70}
            iconClass="!size-10 transition-transform duration-300 group-hover:scale-110 lg:!size-14 xl:!size-[70px]"
          />
        </RevealOnScroll>
      ))}
    </div>
  );
};

export default VisionMissionSection;
